import { useTranslation } from 'react-i18next'
import { invalidateNews, useGetAdminNewsArticle, useUpdateAdminNews } from 'src/api/news'
import { CenteredSpinner } from 'src/components/Spinner'
import { IUpdateNewsArticle } from 'src/generated-types/news'
import { NewsArticleForm, NewsArticleFormValues } from 'src/forms/NewsArticleForm'
import { ShowDialogProps } from 'src/show-dialog'

interface AdminUpdateNewsArticleDialogProps extends ShowDialogProps {
  articleId: number
}

const AdminUpdateNewsArticleDialog: React.FC<AdminUpdateNewsArticleDialogProps> = ({ pop, articleId }) => {
  const { t: translate } = useTranslation(['common', 'news'])
  const { data: article, isLoading: isLoadingArticle } = useGetAdminNewsArticle(articleId)
  const updateMutation = useUpdateAdminNews(articleId)

  const handleSubmit = async (values: NewsArticleFormValues) => {
    const payload: IUpdateNewsArticle = { ...values, id: articleId }
    await updateMutation.mutateAsync(payload)
    invalidateNews.getAdminNews()
    invalidateNews.getAdminNewsArticle(articleId)
    pop(true)
  }

  if (isLoadingArticle) return <CenteredSpinner />

  return (
    <NewsArticleForm
      title={translate('update-news-article', { ns: 'news' })}
      onSubmit={handleSubmit}
      onCancel={() => pop()}
      initialValues={article}
      isLoading={updateMutation.isLoading}
      hideTargetMode
    />
  )
}

export default AdminUpdateNewsArticleDialog
